import React from "react";
import {Accordion, Button, ButtonGroup, Card, Col, Container, Row} from "react-bootstrap";
import Plot from "react-plotly.js";
import {TickDataList} from "./TickDataList";
import {ChartSelector} from "./ChartSelector";
import {IndicatorSelector} from "./IndicatorSelector";


class StockCharts extends React.Component {

    constructor(props) {
        super(props);

        this.symbolOptions = props.symbolOptions;
        this.timeKey = "time"
        this.pendingOrders = "pendingOrders"

        this.tickDataList = React.createRef();

        let hoverTicks = {};
        if(props.chartData != null && props.chartData['8'] != null){
            for (let key in props.chartData['8'] ) {
                hoverTicks[key] = ['a'];
            }
        }

        this.hourArray = ['8','9','10','11','12','13','14'];
        this.state = {
            fullData:props.chartData,
            data: props.chartData[8],
            config: props.config,
            hoverTicks:hoverTicks,
            hoverTime : null,
            currentDataKey: this.symbolOptions[0].chartKey,
            currentDataTitle: this.symbolOptions[0].title,
            indicatorDataKey : "indValue",
            indicatorConfig : props.config.indicatorConfig,
            positionKey : "indPosition",
            revisionNumber :0,
        };
        let xaxisLayout = {
            type: 'date',
            tickformat: '%H:%M:%S',
            tickangle: 85,
        };

        this.layout ={
            width: 1100,
            height: 500,
            margin: {
                l: 50,
                r: 50,
                b: 80,
                t: 40,
                pad: 4
            },
            xaxis: xaxisLayout,
            yaxis: {
                titlefont: {color: 'black'},
                tickfont: {color: 'black'}
            }
            ,showlegend:false
        };

        this.indicatorLayout = {
            width: 1100,
            height: 200,
            margin: {
                l: 50,
                r: 50,
                b: 80,
                t: 40,
                pad: 4
            },
            showlegend:false,
            xaxis: xaxisLayout,
            yaxis: {
                titlefont: {color: 'black'},
                tickfont: {color: 'black'}
            }
        };
        this.changeHour = this.changeHour.bind(this);
        this.onHover = this.onHover.bind(this);
        this.chartSymbolChange = this.chartSymbolChange.bind(this);
        this.indicatorChanged = this.indicatorChanged.bind(this);
    }

    changeHour = function(number) {
        this.setState({
            data: this.state.fullData[number * 1],
        })
    }

    onClick({ click, plotIndex }){

        if(this.state.hoverTime != null){
            if(this.props.selectedPositionChangeHandler){
                this.props.selectedPositionChangeHandler(this.state.hoverTime.getTime())
            }
            let dataIndex = this.state.data[this.timeKey].indexOf(this.state.hoverTime.getTime());
            let startIndex = 0;
            let window = 10;
            if(dataIndex > (startIndex + window)){
                startIndex = dataIndex - (window/2);
            }
            if(dataIndex > (this.state.data[this.timeKey].length - window)){
                startIndex = this.state.data[this.timeKey].length - window;
            }
            let newTicks = {}
            for(let key in this.state.data){
                newTicks[key] = this.state.data[key].slice(startIndex, startIndex + window);
            }
            this.setState({
                hoverTicks:newTicks,
                selectedIndicatorTime: this.state.hoverTime
            });
            this.tickDataList.current.updateData(newTicks);
        }
    };

    onHover({ hover, unhover, plotIndex }) {
        let displayForTime = hover.points[0].x;
        let d = new Date(displayForTime);
        this.setState({
            hoverTime:d
        });
    }

    chartSymbolChange(value){
        this.setState({
            currentDataKey: this.symbolOptions[value].chartKey,
            currentDataTitle: this.symbolOptions[value].title
        })
    }

    indicatorChanged(value, indiConfig) {
        let dataKey ="indValue";
        let newIndicatorConfig = this.state.config.indicatorConfig;
        let positionKey = "indPosition";
        if(this.state.config.indicatorConfig.name !== value){
            dataKey = 'child_indi_' + indiConfig.name + '_value';
            newIndicatorConfig = indiConfig;
            positionKey = 'child_indi_' + indiConfig.name + '_position';
        }
        this.setState({
            indicatorDataKey: dataKey,
            indicatorConfig :newIndicatorConfig,
            positionKey :positionKey,
            revisionNumber: this.state.revisionNumber + 1
        })
        this.tickDataList.current.updateIndicator(dataKey,positionKey);
    }

    isEmpty(array){
        return array === null || array === undefined || array.length === 0;
    }

    render() {
        let response = ""
        if (this.isEmpty(this.state.data)){
            response = <div>No data found for given filters</div>
        }else{
            let hrs = []
            for(let i =0; i < this.hourArray.length; i++) {
                hrs.push(<Button key={"button_"+i} variant="secondary" onClick={() =>  this.changeHour(this.hourArray[i])}>{this.hourArray[i]}:00</Button>);
            }
            response =
                <div>
                <Container>
                        <Row>
                            <Col>
                                <div>Ticks: {this.state.data[this.timeKey].length} Time:{new Date(this.state.data[this.timeKey][0]).toLocaleDateString()}</div>
                            </Col>
                        </Row>
                    <Row>
                        <Col>
                            <ChartSelector onChange={this.chartSymbolChange}  symbolOptions = {this.symbolOptions} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <IndicatorSelector onChange={this.indicatorChanged} config = {this.state.config} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <ButtonGroup aria-label="hours">
                                {hrs}
                            </ButtonGroup>
                        </Col>
                    </Row>
                </Container>

                <Accordion key={'tab.charts'} defaultActiveKey={'nno'}>
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle as={Button} variant="link" eventKey={'tab.charts'}>
                                {this.state.currentDataTitle}
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey={'tab.charts'}>
                            <Card.Body>
                                {this.props.children}
                                <Plot

                                    revision = {this.state.revisionNumber}
                                    onHover={hover => this.onHover({ hover, plotIndex: 2 })}
                                    onClick={click => this.onClick({ click, plotIndex: 2 })}
                                    data={[{
                                        x: this.state.data[this.timeKey],
                                        y: this.state.data[this.state.currentDataKey],
                                        type: 'scatter',
                                        mode: 'lines',
                                        name: this.state.currentDataTitle,
                                        marker: {color: 'rgb(102, 102, 102)'},
                                        anchor: 'free',
                                    }, {
                                                x: this.state.data[this.timeKey],
                                                y: this.state.data[this.pendingOrders] === undefined ? [] : this.state.data[this.pendingOrders].map( (value,index, array) => {
                                                    return value === null || value.length === 0  ? null : this.state.data[this.state.currentDataKey][index];
                                                }),
                                                type: 'scatter',
                                                mode: 'lines',
                                                name: 'Active Positions',
                                                text: this.state.data[this.pendingOrders],
                                                marker: {color: 'rgb(255, 219, 77)',size: 9},
                                                anchor: 'free',
                                            }
                                        ,{
                                            x: this.state.data[this.timeKey],
                                            y: this.state.data[this.state.positionKey].map( (value,index, array) => {
                                              return value === "NEUTRAL" ? null : this.state.data[this.state.currentDataKey][index];
                                            }),
                                            type: 'scatter',
                                            mode: 'markers',
                                            name: 'Indicators',
                                            marker: {color:  this.state.data[this.state.positionKey].map( (value, index, array) => {
                                                    let markerColor;
                                                    switch(value) {
                                                        case "LONG":
                                                            markerColor = "green"
                                                            break;
                                                        case "SHORT":
                                                            markerColor = "red"
                                                            break;
                                                        default:
                                                            markerColor = null;
                                                    }
                                                    return markerColor;
                                                }),
                                                size: 8},
                                            anchor: 'free',
                                            text:this.state.data[this.state.positionKey]
                                        }
                                    ]}
                                    layout={ this.layout }
                                />
                                {this.state.indicatorConfig.name}
                                <Plot
                                    revision = {this.state.revisionNumber}
                                    onHover={hover => this.onHover({ hover, plotIndex: 2 })}
                                    onClick={click => this.onClick({ click, plotIndex: 2 })}
                                    data={[ {
                                        x: this.state.data[this.timeKey],
                                        y: this.state.data[this.timeKey].map( (value,index, array) => {return this.state.indicatorConfig.highThreshold}),
                                        type: 'scatter',
                                        mode: 'lines',
                                        name: 'High Threshold',
                                        line: {color: 'rgb(140, 140, 140)', width: 2},
                                        anchor: 'free',
                                    },{
                                        x: this.state.data[this.timeKey],
                                        y: this.state.data[this.timeKey].map( (value,index, array) => {return this.state.indicatorConfig.lowThreshold}),
                                        type: 'scatter',
                                        mode: 'lines',
                                        name: 'Low Threshold',
                                        line: {color: 'rgb(140, 140, 140)', width: 2},
                                        anchor: 'free',
                                    },{
                                        x: this.state.data[this.timeKey],
                                        y: this.state.data[this.state.indicatorDataKey],
                                        type: 'scatter',
                                        mode: 'lines',
                                        name: this.state.indicatorConfig.name,
                                        marker: {color: 'rgb(102, 140, 255)'},
                                        anchor: 'free',
                                    },{
                                            x: this.state.data[this.timeKey],
                                            y: this.state.data[this.state.positionKey].map( (value,index, array) => {
                                                return value === "NEUTRAL" ? null : this.state.data[this.state.indicatorDataKey][index];
                                            }),
                                            type: 'scatter',
                                            mode: 'markers',
                                            name: 'Indicators',
                                            marker: {color:  this.state.data[this.state.positionKey].map( (value, index, array) => {
                                                    let markerColor;
                                                    switch(value) {
                                                        case "LONG":
                                                            markerColor = "green"
                                                            break;
                                                        case "SHORT":
                                                            markerColor = "red"
                                                            break;
                                                        default:
                                                            markerColor = null;
                                                    }
                                                    return markerColor;
                                                }),
                                                size: 5},
                                            anchor: 'free',
                                            text:this.state.data[this.state.positionKey]
                                        }
                                   ]}
                                    layout = { this.indicatorLayout }
                                />
                                <TickDataList ref= {this.tickDataList} tickList={this.state.hoverTicks} displayValue={this.state.currentDataKey }/>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        }
        return response;
    }
}


export {StockCharts}
